export enum TreatmentLabel {
  weed = 'Daninhas',
  planting_failure = 'Falha de Plantio',
  physiology = 'Desempenho fisiológico',
}
export type Treatment = keyof typeof TreatmentLabel
